import {
  ConfigSDK,
  Env,
  PullType,
  SystemType,
  Target,
} from '@tencent/shiply-js-sdk';
import { makeAutoObservable } from 'mobx';
import { getUserId } from '@/infrastructure/auth';
import { ENV } from '@/infrastructure/env-config';
import { logger } from '@/infrastructure/logger';

const configSDK = new ConfigSDK({
  systemType: SystemType.CONFIG,
  appID: ENV.isProd ? '7f2d5378c0' : 'b3e7d26cb5',
  appToken: ENV.isProd ? '33014359-1a25-4a75-bb02-e63975f5357a' : '9298934f-1757-4c2f-8b64-aae897f9de2b',
  env: ENV.isProd ? Env.PROD : Env.TEST,
  pullType: PullType.SINGLE,
  target: Target.PROJECT,
  guid: getUserId(), // 可不填，但和 pull中的guid参数必须有一个要填
  usePolaris: ENV.isProd,
});

export interface IRightlyNotice {
  version: number;
  platform: string;
  content: string[];
}

export interface IRightlyBanner {
  id: string;
  content: string;
}

// 白名单，空值全开，有值按值开
export interface IRightlyRoute {
  path: string;
  products?: string[];
}

// 白名单，空值全开，有值按值开
export interface IRightlyCoverdStatusOption {
  key: string;
  products?: string[];
  platforms?: string[];
}

export class RightlyStore {
  loaded = false;
  notices: IRightlyNotice[] = [];
  banners: IRightlyBanner[] = [];
  routes: IRightlyRoute[] = [];
  coveredStatusOptions: IRightlyCoverdStatusOption[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    this.load();
  }

  private parseConfig = (res: any, configType: string) => {
    try {
      const configStr = res?.configs?.find((config: any) => config.key === configType)?.value || '';
      const config = JSON.parse(configStr);
      const value = config?.config_value;
      return value ? JSON.parse(config?.config_value) : undefined;
    } catch (e) {
      logger.error('RightlyStore|config error:', e);
      return undefined;
    }
  };

  private load = async () => {
    this.loaded = false;
    const res = await configSDK.pull({
      keys: ['notice', 'banner', 'coveredStatusOption', 'route'],
      customProperties: {
        portal: process.env.APP_VERSION,
      },
    });
    this.notices = this.parseConfig(res, 'notice') || [];
    this.banners = this.parseConfig(res, 'banner') || [];
    this.routes = this.parseConfig(res, 'route') || [];
    this.coveredStatusOptions = this.parseConfig(res, 'coveredStatusOption') || [];
    this.loaded = true;
  };
}
